import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { CorporateActionModal } from '../models/corporate-action'

@Component({
  selector: 'nf-delete-confirm-modal',
  template: `
    <div class="modal-header" hsDraggable="modal-dialog">
      <h4 class="modal-title">
        Are you sure you want to delete this corporate action?
      </h4>
      <button
        nf-icon-button
        icon="close"
        class="btn-bare"
        ngbTooltip="Close"
        (click)="activeModal.close()"
      >
        Close
      </button>
    </div>
    <div class="modal-body" hsDraggable="modal-dialog">
      <p>
        This operation cannot be undone and will cause issues for the corporate
        action to be deleted.
      </p>
    </div>
    <div class="modal-footer" hsDraggable="modal-dialog">
      <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
      <button nf-button="submit" (click)="activeModal.close(true)"></button>
    </div>
  `,
})
export class CorporateActionsDeleteConfirmationModal {
  @Input() corporateActionInput?: CorporateActionModal
  constructor(public activeModal: NgbActiveModal) {}
}
